"use strict";

window.addEventListener("load", function () {

    /*let videoBg = document.getElementById("video-bg");

    if (videoBg) {
        var backgrVideo = '<video muted autoplay loop preload="auto">'
                + '<source src="/static_v2/video/vid_backgr.mp4" type="video/mp4">'
                + '</video>';
        videoBg.insertAdjacentHTML('beforeend', backgrVideo);
    }*/

    let blockAction = document.querySelector(".block3.blockakcii");

    if (blockAction) {
        // blockAction.style.backgroundImage = "url(/static_v2/img/test_fon-b3.jpg)";
        blockAction.style.backgroundImage = "url(/static_v2/img/fon-akcii.png)";
        blockAction.style.backgroundPosition = "center";
        // blockAction.style.backgroundSize = "cover";
        blockAction.style.boxShadow = "0 0 6px -1px rgb(0 0 0 / 25%)";
        // blockAction.style.backgroundAttachment = "fixed";
    }

}, {passive: true});

$(document).ready(function () {
    let wbutton = document.getElementById('watsapp-button')
    if (wbutton) {
        const btnWrapper = document.createElement("div");
        btnWrapper.classList.add("btn-wrap");
        btnWrapper.style.marginTop = "10px";

        const link = document.createElement("a");
        link.classList.add("mbtn");
        link.style.display = 'unset';
        link.setAttribute("href", "https://wa.me/79771250392?text=Прошу оценить стоимость кузовного ремонта");
        link.setAttribute("target", "_blank");
        link.setAttribute("onclick", "yaCounter7501828.reachGoal('wotsap'); return true;");
        link.textContent = "Оценить стоимость по фото";

        btnWrapper.appendChild(link);
        document.body.appendChild(btnWrapper);

        let btn = document.getElementById('header-menu-button');
        btn.parentNode.replaceChild(btnWrapper, btn);

        const btnWrapper2 = document.createElement("div");
        btnWrapper2.className = "col-12 col-md-6 col-lg-4 col-xl-4";

        const link2 = document.createElement("a");
        link2.classList.add("mbtn");
        link2.setAttribute("href", "https://wa.me/79771250392?text=Прошу оценить стоимость кузовного ремонта");
        link2.setAttribute("target", "_blank");
        link2.setAttribute("onclick", "yaCounter7501828.reachGoal('wotsap'); return true;");
        link2.textContent = "Оценить стоимость по фото";

        btnWrapper2.appendChild(link2);
        document.body.appendChild(btnWrapper2);

        let underpriceBtn = document.getElementById('btn-uderprice');
        underpriceBtn.parentNode.replaceChild(btnWrapper2, underpriceBtn);
    }


    /* YANDEX MAPS PRELOAD */
    var elements1 = document.querySelectorAll('.block-lob');
    var elements2 = document.querySelectorAll('.block-sev');
    var elements3 = document.querySelectorAll('.block-ud');
    var elements4 = document.querySelectorAll('.block-nau');
    var p = window.location.pathname;


    if ((elements1.length == 0 || elements2.length == 0 || elements3.length == 0 || elements4.length == 0) && !(p.length === 0 || p === "/")) {
        if (!check_if_load) { // проверяем первый ли раз загружается Яндекс.Карта, если да, то загружаем
            // Чтобы не было повторной загрузки карты, мы изменяем значение переменной
            check_if_load = true;
            // Показываем индикатор загрузки до тех пор, пока карта не загрузится
            spinner.addClass('is-active');
            // Загружаем API Яндекс.Карт
            loadScript("https://api-maps.yandex.ru/2.1/?lang=ru_RU&amp;loadByRequire=1", function () {
                // Как только API Яндекс.Карт загрузились, сразу формируем карту и помещаем в блок с идентификатором "map-yandex"
                ymaps.load(init);
            });
        }
    }

    /* JS for hidden block "preparing to winter"
     $(".pocket_card_toggle").on('click', function () {
     var blockNumb = $(this).data("toggle");
     $("#pocket_card_" + blockNumb).slideToggle();
     });
     */

    function hide_mobile(elem) {
        elem.classList.add('to_hide');
        yaCounter7501828.reachGoal('show_number');
    }

    $('.burger').click(function (event) {
        $('.header-burger-wrap').toggleClass("opened");
        $(".header-card-vip-close").trigger('click');
        $('.header-menu').slideToggle();
        if ($('.header-mobile-brands').css('display') == 'block') {
            $('.header-mobile-brands').slideUp();
        }
        if ($('.header-mobile-service').css('display') == 'block') {
            $('.header-mobile-service').slideUp();
        }
    });

    $('#brand-mobile-menu').click(function (event) {
        //$('.header-burger-wrap').toggleClass("opened");
        $('.header-mobile-brands').slideToggle();
    });

    $('#service-mobile-menu').click(function (event) {
        //$('.header-burger-wrap').toggleClass("opened");
        $('.header-mobile-service').slideToggle();
    });

    $(".header-card").on("mouseenter", function () {
        let site_width = document.body.offsetWidth;
        let menu = $(this).find(".header-card-vip");
        menu.css("display", "");
        let elemWidht = menu.width();
        let left = Math.round((site_width - elemWidht) / 2) - 15;
        menu.css("left", left);
    });

    $(".header-card-vip-close").on("click", function () {
        var elem = $(this).parent().parent();
        elem.css("display", "none");
    });

//закрыть фон во всю ширину(нужно сделать анимацию появления контента)
    $('.videoblock-close').click(function (event) {
        $('.block1 .container2 .main__row').slideToggle();
        $('.block1 .main__left-bg').slideToggle();
        $('.block1 .video-mask').slideToggle();
        $('.videoblock-wrap').slideToggle();
        $('.videoblock-close').slideToggle();
        $('.main__bg-brand-list').slideUp();
        $('#video-bg video').css({width: '60%'});
    });

//открыть фон во всю ширину (нужно сделать анимацию пропадания контента)
    $('.videobtn-wrap').click(function (event) {
        $('.block1 .container2 .main__row').slideToggle();
        $('.block1 .main__left-bg').slideToggle();
        $('.block1 .video-mask').slideToggle();
        $('.videoblock-wrap').slideToggle();
        $('.videoblock-close').slideToggle();
        $('#video-bg video').css({width: '100%'});
        $('.block1').css({height: '100vh'});
    });

    $('.block1-slide-show_all').click(function () {
        $('.videobtn-wrap').trigger('click');
        $('.main__bg-brand-list').slideDown();
    });

    $('.serv-btn').click(function (event) {
        $('.header-card3-vip3').slideToggle();
        $('.header-burger-wrap').removeClass("opened");
        $('.header-menu').slideUp();
    });

// открытие/закрытие модальных окон с видеоотзывами (видимо нужно оптимизировать)
    $('.videootzbtn').click(function (event) {
        var blockNumber = $(event.currentTarget).data("videoblock");
        $('.videootz-big' + blockNumber).slideDown();
    });
    $('.videootz-close').click(function (event) {
        $('.videootz-big').hide();
    });


//открываем/закрываем большой слайдер с отзывами (требует доработки - чтобы при нажатии на отзыв открывался этот же отзыв)
    $('.otziv-slider-block').click(function (event) {

        if ($(window).width() > 992) {
            $('.bigslider-foot-wrap').slideToggle(400);
            $('.header').slideToggle(400);
            $('.bigslider-foot-for').slick({
                slidesToShow: 1,
                slidesToScroll: 1
            });
        }
    });
    $('.bigslider-foot-close').click(function (event) {
        $('.bigslider-foot-wrap').slideToggle(400);
        $('.header').slideToggle(400);
    });

//слайдер с отзывами (миниатюры)
    $('.footslider').slick({
        infinite: true,
        slidesToShow: 6,
        centerMode: false,
        slidesToScroll: 1,
        lazyLoad: 'progressive',
        responsive: [
            {
                breakpoint: 1799,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

//убираем/показываем соц. сети и информацию о клиентах при скроле
    var headertop = $('.header').height();
    $(window).scroll(function () {
        if ($(window).width() > 1799) {
            if ($(window).scrollTop() > headertop) {
                $('.header-social').css({display: 'none'});
                $('.header-client').css({display: 'none'});
            } else {
                $('.header-social').css({display: 'block'});
                $('.header-client').css({display: 'block'});
            }
        } else if ($(window).width() > 991) {
            if ($(window).scrollTop() > headertop) {
                $('.header-client').css({display: 'none'});
            } else {
                $('.header-client').css({display: 'block'});
            }
        }
    });

    if ($("div").is(".block1-slider")) {

        var makedMineSlider = false;
        var makedMobileMineSlider = false;
        var mobileMainSlider = $(".block1-slide").clone();

        var mainSliderInit = function () {
            $('.block1-slide').slick({
                slidesToShow: 10,
                slidesToScroll: 10,
                lazyLoad: 'progressive',
                responsive: [
                    {
                        breakpoint: 4200,
                        settings: {
                            slidesToShow: 8,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 2300,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 1799,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 2
                        }
                    }
                ]
            });
        };

        var mainMobileSliderInit = function () {

            mobileMainSlider.attr("id", "brand_mob_slider");
            mobileMainSlider.addClass("block1-slider-mobile");
            $("#mobile_brand_slider").append(mobileMainSlider);

            $("#brand_mob_slider").slick({
                infinite: true,
                slidesToShow: 1,
                centerMode: false,
                slidesToScroll: 1,
                lazyLoad: 'progressive'
            });

            makedMobileMineSlider = true;

        };

        $(window).on("resize", function () {
            if (!makedMineSlider && window.innerWidth > 575) {
                mainSliderInit();
                makedMineSlider = true;
            } else if (!makedMobileMineSlider) {
                mainMobileSliderInit();
            }
        });

        if (!makedMineSlider && window.innerWidth > 575) {
            mainSliderInit();
            makedMineSlider = true;
        } else if (!makedMobileMineSlider) {
            mainMobileSliderInit();
        }
    }

    if ($("div").is(".slider_header_iphone")) {
        $('.slide_header_iphone').slick({
            dots: true,
            infinite: true,
            arrows: false,
            slidesToShow: 1,
            centerMode: false,
            slidesToScroll: 1,
            lazyLoad: 'progressive'
        });
    }

    /* JS for hidden block "preparing to winter"
     if ($("div").is(".pocket_card_sl")) {
     $('.pocket_card_sl').slick({
     slidesToShow: 3,
     infinity: false,
     slidesToScroll: 1,
     responsive: [

     {
     breakpoint: 1200,
     settings: {
     slidesToShow: 2,
     slidesToScroll: 1
     }
     },
     {
     breakpoint: 850,
     settings: {
     slidesToShow: 1,
     slidesToScroll: 1
     }
     },
     {
     breakpoint: 500,
     settings: {
     slidesToShow: 1,
     slidesToScroll: 1
     }
     }
     ]
     });
     }
     */
    $('.block5-slider').slick({
        slidesToShow: 4,
        infinity: false,
        slidesToScroll: 1,
        lazyLoad: 'progressive',
        responsive: [
            {
                breakpoint: 1799,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.block6-slider').slick({
        slidesToShow: 4,
        infinity: false,
        slidesToScroll: 1,
        lazyLoad: 'progressive',
        responsive: [
            {
                breakpoint: 1799,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.block2-slider').slick({
        slidesToShow: 6,
        infinity: false,
        slidesToScroll: 1,
        lazyLoad: 'progressive',
        responsive: [
            {
                breakpoint: 1799,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    // $('.block-service-slider').slick({
    //     slidesToShow: 8,
    //     infinity: false,
    //     centerMode: false,
    //     slidesToScroll: 1,
    //     lazyLoad: 'progressive',
    //     responsive: [
    //         {
    //             breakpoint: 1799,
    //             settings: {
    //                 slidesToShow: 6,
    //                 slidesToScroll: 6
    //             }
    //         },
    //         {
    //             breakpoint: 1500,
    //             settings: {
    //                 slidesToShow: 4,
    //                 slidesToScroll: 4
    //             }
    //         },
    //         {
    //             breakpoint: 991,
    //             settings: {
    //                 slidesToShow: 3,
    //                 slidesToScroll: 3
    //             }
    //         },
    //         {
    //             breakpoint: 767,
    //             settings: {
    //                 slidesToShow: 2,
    //                 slidesToScroll: 2
    //             }
    //         }
    //     ]
    // });

    $('.card-wrap').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        lazyLoad: 'progressive',
        responsive: [
            {
                breakpoint: 1799,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.block4-slider').slick({
        slidesToShow: 4,
        infinity: false,
        slidesToScroll: 1,
        lazyLoad: 'progressive',
        responsive: [
            {
                breakpoint: 1799,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.video-otzyvsl').slick({
        slidesToShow: 3,
        infinity: false,
        slidesToScroll: 1,
        lazyLoad: 'progressive',
        responsive: [

            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    if ($("div").is("#main_services")) {

        var makedSlider = false;
        var makeServiceSlider = function () {
            if (!makedSlider) {
                makedSlider = true;
                var mainServices = $("#main_services").clone();
                $("#main_services").css("display", "none");
                mainServices.attr("id", "services_mob_slider").addClass("services__slider");
                mainServices.children("div").each(function (i, elem) {
                    $(elem).removeClass("col-12 col-md-6 col-lg-6 col-xl-6");
                });
                mainServices.insertAfter("#main_services");
                let slideHeader = document.createElement("div");
                slideHeader.id = "model_slider_head";
                slideHeader.classList.add("mob_zag", "only_mobile");
                //slideHeader.prepend("Выбрать услугу");
                document.getElementById("main_services").insertAdjacentElement("afterEnd", slideHeader);

                $("#services_mob_slider").slick({
                    infinite: true,
                    slidesToShow: 1,
                    centerMode: false,
                    slidesToScroll: 1,
                    lazyLoad: 'ondemand'
                });
            }
            if (makedSlider) {
                var toogle = 'slider';
                $("#show_service_panel").on("click", function () {
                    var button = $(this);
                    if (toogle == 'slider') {
                        $("#services_mob_slider").slideUp('fast');
                        $("#main_services").slideDown('fast');
                        button.empty().append("Скрыть");
                        toogle = 'panel';
                    } else {
                        $("#services_mob_slider").slideDown('fast');
                        $("#main_services").slideUp('fast');
                        button.empty().append("Показать все");
                        toogle = 'slider';
                    }
                });
            }
        };
        var deleteServiceSlider = function () {
            if (makedSlider) {
                makedSlider = false;
                $("#main_services").css("display", "");
                $("#services_mob_slider").remove();
                document.getElementById("model_slider_head").remove();
            }
        };
        if (window.innerWidth < 767) {
            makeServiceSlider();
        } else {
            deleteServiceSlider();
        }

        $(window).on('resize', function () {
            if (window.innerWidth < 767) {
                makeServiceSlider();
            } else {
                deleteServiceSlider();
            }
        });

    }

    // if ($("div").is("#contact_list")) {
    //
    //     var makedSliderTest = false;
    //
    //     var makeServiceSliderTest = function () {
    //         if (!makedSliderTest) {
    //             makedSliderTest = true;
    //             var mainServices = $("#contact_list").clone();
    //             $("#contact_list").css("display", "none");
    //             $("#contact_list").html('');
    //             mainServices.attr("id", "contact_mob_slider").addClass("services__slider");
    //             mainServices.children("div").each(function (i, elem) {
    //                 $(elem).removeClass("col-lg-3 col-sm-6 block-links-columns");
    //             });
    //             mainServices.insertAfter("#contact_list");
    //             let slideHeader = document.createElement("div");
    //             slideHeader.id = "model_slider_head";
    //             slideHeader.classList.add("mob_zag", "only_mobile");
    //             document.getElementById("contact_list").insertAdjacentElement("afterEnd", slideHeader);
    //
    //             $("#contact_mob_slider").slick({
    //                 infinite: true,
    //                 slidesToShow: 1,
    //                 centerMode: false,
    //                 slidesToScroll: 1,
    //                 lazyLoad: 'ondemand'
    //             });
    //             // Севастопольский
    //             var sev=document.getElementById("sev").innerHTML;
    //             sev=sev.replace("<div>","");
    //             sev=sev.replace("</div>","");
    //             $('.sevPrint4').html(sev);
    //             let link_sev=sev.replace("(","");
    //             link_sev=link_sev.replace(")","");
    //             link_sev=link_sev.replace(/-/g,"");
    //             link_sev=link_sev.replace(/ /g,"");
    //             if(document.getElementsByClassName("sevPrint4"))document.getElementsByClassName('sevPrint4').href = 'tel:'+link_sev;
    //             // Удальцова
    //             var ydal=document.getElementById("ydal").innerHTML;
    //             ydal=ydal.replace("<div>","");
    //             ydal=ydal.replace("</div>","");
    //             $('.ydalPrint4').html(ydal);
    //             let link_ydal=ydal.replace("(","");
    //             link_ydal=link_ydal.replace(")","");
    //             link_ydal=link_ydal.replace(/-/g,"");
    //             link_ydal=link_ydal.replace(/ /g,"");
    //             if(document.getElementsByClassName("ydalPrint4"))document.getElementsByClassName('ydalPrint4').href = 'tel:'+link_ydal;
    //             // Лобненская
    //             var lbn=document.getElementById("lbn").innerHTML;
    //             lbn=lbn.replace("<div>","");
    //             lbn=lbn.replace("</div>","");
    //             $('.lbnPrint4').html(lbn);
    //             let link_lbn=lbn.replace("(","");
    //             link_lbn=link_lbn.replace(")","");
    //             link_lbn=link_lbn.replace(/-/g,"");
    //             link_lbn=link_lbn.replace(/ /g,"");
    //             if(document.getElementsByClassName("lbnPrint4"))document.getElementsByClassName('lbnPrint4').href = 'tel:'+link_lbn;
    //             // Калужская
    //             var klg=document.getElementById("klg").innerHTML;
    //             klg=klg.replace("<div>","");
    //             klg=klg.replace("</div>","");
    //             $('.klgPrint4').html(klg);
    //             let link_klg=klg.replace("(","");
    //             link_klg=link_klg.replace(")","");
    //             link_klg=link_klg.replace(/-/g,"");
    //             link_klg=link_klg.replace(/ /g,"");
    //             if(document.getElementsByClassName("klgPrint4"))document.getElementsByClassName('klgPrint4').href = 'tel:'+link_klg;
    //
    //         }
    //     };
    //     // var deleteServiceSlider = function () {
    //     //     if (makedSlider) {
    //     //         makedSlider = false;
    //     //         $("#contact_list").css("display", "");
    //     //         $("#contact_mob_slider").remove();
    //     //         document.getElementById("model_slider_head").remove();
    //     //     }
    //     // };
    //
    //     if (window.innerWidth < 767) {
    //         makeServiceSliderTest();
    //     } else {
    //         //deleteServiceSlider();
    //     }
    //
    //     $(window).on('resize', function () {
    //         if (window.innerWidth < 767) {
    //             makeServiceSliderTest();
    //         }
    //     });
    //     //
    //     // if (makedSliderTest) {
    //     //     var toogle = 'slider';
    //     //     $("#show_service_panel").on("click", function () {
    //     //         var button = $(this);
    //     //         if (toogle == 'slider') {
    //     //             $("#services_mob_slider").slideUp('fast');
    //     //             $("#main_services").slideDown('fast');
    //     //             button.empty().append("Скрыть");
    //     //             toogle = 'panel';
    //     //         } else {
    //     //             $("#services_mob_slider").slideDown('fast');
    //     //             $("#main_services").slideUp('fast');
    //     //             button.empty().append("Показать все");
    //     //             toogle = 'slider';
    //     //         }
    //     //     });
    //     // }
    //
    // }

    if ($("div").is("#block-service-slider")) {
        let toogle_service = 'slider';
        $("#block-service-slider").slick({
            infinite: true,
            slidesToShow: 8,
            centerMode: false,
            slidesToScroll: 8,
            lazyLoad: 'progressive',
            responsive: [
                {
                    breakpoint: 1601,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6
                    }
                },
                {
                    breakpoint: 1439,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        $("#show_model_panel_service_slider").show();

        $("#show_model_panel_service_slider").on("click", function () {
            var button = $(this);
            if (toogle_service == 'slider') {
                $("#block-service-slider").slideUp('fast');
                $("#block-service-slider-all").slideDown('fast');
                button.empty().append("Скрыть");
                toogle_service = 'panel';
            } else {
                $("#block-service-slider").slideDown('fast');
                $("#block-service-slider-all").slideUp('fast');
                button.empty().append("Показать все");
                toogle_service = 'slider';
            }
        });
        const count_block_service_slide = $('#block-service-slider').find('.slick-track').find('.block-service-slider__item').length;
        if (count_block_service_slide < 8) {
            // если слайдов меньше 8, то раскрываем подробный список
            $("#block-service-slider").slideUp('fast');
            $("#block-service-slider-all").slideDown('fast');
            $('#show_model_panel_service_slider').css({'display': 'none'});
            toogle_service = 'panel';
        }
    }

    if ($("div").is("#slider_model")) {
        let toogle = 'slider';
        let slickLaunch = false;

        let newBlock = $("#slider_model").clone();
        newBlock.attr("id", "panel_model").css("display", "none").insertAfter("#slider_model");

        let newBlockLength = newBlock.children(".model__item").length;
        console.log(newBlockLength);
        if (window.innerWidth > 1600 && newBlockLength > 8) {
            slickLaunch = true;
        }
        if (window.innerWidth > 1439 && window.innerWidth <= 1600 && newBlockLength > 6) {
            slickLaunch = true;
        }
        if (window.innerWidth > 991 && window.innerWidth <= 1439 && newBlockLength > 5) {
            slickLaunch = true;
        }
        if (window.innerWidth > 767 && window.innerWidth <= 991 && newBlockLength > 2) {
            slickLaunch = true;
        }
        if (window.innerWidth > 0 && window.innerWidth <= 767 && newBlockLength > 1) {
            slickLaunch = true;
        }

        if (slickLaunch) {
            $("#slider_model").slick({
                infinite: true,
                slidesToShow: 8,
                centerMode: false,
                slidesToScroll: 1,
                lazyLoad: 'progressive',
                responsive: [
                    {
                        breakpoint: 1601,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1439,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 567,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
            $("#show_model_panel").show();
        }

        $("#show_model_panel").on("click", function () {
            var button = $(this);
            if (toogle == 'slider') {
                $("#slider_model").slideUp('fast');
                $("#panel_model").slideDown('fast');
                button.empty().append("Скрыть");
                toogle = 'panel';
            } else {
                $("#slider_model").slideDown('fast');
                $("#panel_model").slideUp('fast');
                button.empty().append("Показать все");
                toogle = 'slider';
            }
        });
    }

    if ($("div").is("#show_video_panel")) {
        $("#show_video_panel").on("click", function () {
            if (toogle !== 'panel' && toogle !== 'slider') {
                toogle = 'slider';
            }
            var button = $(this);
            if (toogle == 'slider') {
                $("#slider_video").slideUp('fast');
                $("#panel_video").slideDown('fast');
                button.empty().append("Скрыть");
                toogle = 'panel';
            } else {
                $("#slider_video").slideDown('fast');
                $("#panel_video").slideUp('fast');
                button.empty().append("Показать все");
                toogle = 'slider';
            }
        });
    }

    if ($("div").is("#slider_brand")) {
        let toogle = 'slider';
        let slickLaunch = false;

        let newBlock = $("#slider_brand").clone();
        newBlock.attr("id", "panel_brand").css("display", "none").insertAfter("#slider_brand");

        let newBlockLength = newBlock.children(".brand__item").length;
        console.log(newBlockLength);
        if (window.innerWidth > 1600 && newBlockLength > 8) {
            slickLaunch = true;
        }
        if (window.innerWidth > 1439 && window.innerWidth <= 1600 && newBlockLength > 6) {
            slickLaunch = true;
        }
        if (window.innerWidth > 991 && window.innerWidth <= 1439 && newBlockLength > 5) {
            slickLaunch = true;
        }
        if (window.innerWidth > 767 && window.innerWidth <= 991 && newBlockLength > 2) {
            slickLaunch = true;
        }
        if (window.innerWidth > 0 && window.innerWidth <= 767 && newBlockLength > 1) {
            slickLaunch = true;
        }

        if (slickLaunch) {
            $("#slider_brand").slick({
                infinite: true,
                slidesToShow: 8,
                centerMode: false,
                slidesToScroll: 1,
                lazyLoad: 'progressive',
                responsive: [
                    {
                        breakpoint: 1601,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1439,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 567,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
            $("#show_brand_panel").show();
        }

        $("#show_brand_panel").on("click", function () {
            var button = $(this);
            if (toogle == 'slider') {
                $("#slider_brand").slideUp('fast');
                $("#panel_brand").slideDown('fast');
                button.empty().append("Скрыть");
                toogle = 'panel';
            } else {
                $("#slider_brand").slideDown('fast');
                $("#panel_brand").slideUp('fast');
                button.empty().append("Показать все");
                toogle = 'slider';
            }
        });
    }
    $(document).ready(function () {
        $('#button_select_block_ul__forma').click(() => {
            $('#list_select_block_ul__forma').css("display", "block");
        });
        $('.env_click_list').on('click', function () {
            const type = $(this).data('type');
            const name = $(this).data('name');
            let real_name = "";
            if (type === 'forma')
                $('#selectdealer1').val(name);
            if (name === 'michurinskiy')
                real_name = "Мичуринский";
            else if (name === 'sevastopolskoy')
                real_name = "Севастопольский";
            else if (name === 'sevastopolskoy_cleaning')
                real_name = "Севастопольский";
            else if (name === 'dmitrovka')
                real_name = "Дмитровка";
            else if (name === 'dmitrovka_cleaning')
                real_name = "Дмитровка";
            else if (name === 'koluzshskaya')
                real_name = "Калужская";
            else
                real_name = name;
            $('#button_select_block_ul__' + type).html(real_name);
            $('#list_select_block_ul__' + type).css("display", "none");
        });
    });

    if ($("div").is(".model__servicepanel")) {

        $("#show_servicepanel").on("click", function () {
            $(".model__servicepanel").addClass("opened");
            $(this).css("display", "none");
        });

    }

    if ($("div").is("#hidden_services")) {

        $("#show_servicepanel").on("click", function () {
            $(".showbutton__block").slideUp();
            $("#hidden_services").slideDown();
        });

    }

    if ($("ul").is('.accordeon__price')) {
        var Accordion = function (el, multiple) {
            this.el = el || {};
            // more then one submenu open?
            this.multiple = multiple || false;

            var dropdownlink = this.el.find('.price__group');
            dropdownlink.on('click',
                {el: this.el, multiple: this.multiple},
                this.dropdown);
        };

        Accordion.prototype.dropdown = function (e) {
            var $el = e.data.el,
                $this = $(this),
                //this is the ul.submenuItems
                $next = $this.next();

            $next.slideToggle();
            $this.parent().toggleClass('open');

            if (!e.data.multiple) {
                //show only one menu at the same time
                $el.find('.price__items').not($next).slideUp().parent().removeClass('open');
            }
        };

        var accordion = new Accordion($('.accordeon__price'), false);

        let priceGroups = $('.accordeon__price').find('.price__group');

        if (priceGroups.length == 1) {
            priceGroups.first().trigger("click");
        } else if ($(window).width() > 1) { // 991
            priceGroups.first().trigger("click");
        }

    }

    if ($("div").is("#portfolio_block")) {

        $("#portfolio_slider").slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1799,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });


        document.addEventListener('DOMContentLoaded', function () {
            $('a[rel="portfolio_group"]').fancybox({
                'transitionIn': 'none',
                'transitionOut': 'none',
                'titlePosition': 'over',
                'titleFormat': function (title, currentArray, currentIndex, currentOpts) {
                    return '<span id="fancybox-title-over">Image ' + (currentIndex + 1) + ' / ' + currentArray.length + (title.length ? ' &nbsp; ' + title : '') + '</span>';
                }
            });

        }, {passive: true});
    }

    const width_screen = window.screen.width;
    // if(width_screen >= 700){
    //     $(".content__colapse").addClass("content__uncolapse");
    //     $(".content__gradient").css("display", "none");
    //     $('#content_readmore').css("display", "none");
    // }
    if ($("div").is(".content__colapse")) {
        $("#content_readmore").on("click", function () {
            $(".content__colapse").addClass("content__uncolapse");
            $(".content__gradient").css("display", "none");
            $(this).css("display", "none");
        });
    }

    if ($("div").is("#news_slider")) {

        $('#news_slider').slick({
            slidesToShow: 3,
            infinite: false,
            slidesToScroll: 1,
            lazyLoad: 'progressive',
            responsive: [

                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

    }

    if ($("div").is("#portworks_slider")) {

        $('#portworks_slider').slick({
            slidesToShow: 3,
            infinite: false,
            slidesToScroll: 1,
            lazyLoad: 'progressive',
            responsive: [

                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

    }
    ;

    if ($("div").is("#portworks")) {

        $('#show_more_portfolio').on('click', function () {
            let button = $(this);
            let next = button.data('next');
            $.ajax({
                type: 'POST',
                url: '/ajax/portfolio.php',
                data: {
                    next: next
                },
                success: function (html) {
                    button.data('next', (next + 6));
                    let block = document.getElementById("portworks");
                    block.insertAdjacentHTML('beforeEnd', html);
                    $('.videootzbtn').click(function (event) {
                        var blockNumber = $(event.currentTarget).data("videoblock");
                        $('.videootz-big' + blockNumber).slideDown();
                    });
                    //$('.videootz-close').click(function (event) {
                    //    $('.videootz-big').hide();
                    //});
                    $('.item_new').fadeIn();
                }
            });

        });

        $('#show_more_video').on('click', function () {
            let button = $(this);
            let next = button.data('next');
            $.ajax({
                type: 'POST',
                url: '/ajax/videoblog.php',
                data: {
                    next: next
                },
                success: function (html) {
                    button.data('next', (next + 6));
                    let block = document.getElementById("portworks");
                    block.insertAdjacentHTML('beforeEnd', html);
                    $('.item_new').fadeIn();
                }
            });

        });

    }

    var bLazy = new Blazy({loadInvisible: true});
    $(".slick-arrow").on('click', function () {
        var bLazy = new Blazy({loadInvisible: true});
    });
});

/* MODALS FORMS */
const Modal = {
    show: id => {
        $.magnificPopup.open({
            items: {
                src: id,
                type: 'inline'
            },
            callbacks: {
                close: function () {
                    setTimeout(() => {
                        $('html').css('overflow: visible');
                    }, 10);
                }
            }
        });
    },
    hide: () => {
        $.magnificPopup.close();
    }
};

$('.popup-open').click(function () {
    var formSelect = $("#callback-popup").find("select");
    formSelect.children('option').each(function (i, elem) {
        $(elem).removeAttr('selected');
    });
    $("#job-popup").data("vac", $(this).data('vac'));
    Modal.show('#' + $(this).data('popup'));
});

$('.popup-open-dealer').click(function () {
    var dealer = $(this).data('dealer');
    var formSelect = $("#callback-popup").find("select");
    formSelect.children('option').each(function (i, elem) {
        let value = $(elem).val();
        if (value != dealer) {
            $(elem).removeAttr('selected');
        } else {
            $(elem).attr("selected", true);
        }
    });
    Modal.show('#' + $(this).data('popup'));
});

$('input[name="phone"]').inputmask('+7 (999) 999-99-99');

class Form {
    constructor(obj) {
        this.form = obj;
        this.status = 'error';
    }

    getValues() {
        if (!this.values) {
            this.values = {};

            let serialize = this.form.serializeArray()
            for (let i in serialize)
                this.values[serialize[i].name] = serialize[i].value;
        }

        return this.values;
    }

    isValid() {
        this.errors = {};

        // Проверка на required
        for (let i = 0; i < this.form.find('[required]').length; i++) {
            let elem = this.form.find('[required]').eq(i);

            if (elem.val() == '') {
                this.errors[elem.attr('name')] = this.errors[elem.attr('name')] || [];

                this.errors[elem.attr('name')].push('Поле обязательно для заполнения');
            }
        }

        // проверка phone
        if (!this.form.find('[name="nophone"]')) {
            if (this.form.find('[name="phone"]')) {
                if (/^[\+]?\d?[ ]?[\(]?\d{3}[\)]?[ ]?\d{2,3}[- ]?\d{2}[- ]?\d{2}$/gi.test(this.form.find('[name="phone"]').val()) == false) {
                    this.errors.phone = this.errors.phone || [];

                    this.errors.phone.push('Укажите телефон полностью');
                }
            }
        }
        return Object.keys(this.errors).length == 0;
    }

    setStatus(status) {
        this.status = status;
    }

    getStatus() {
        return '#' + this.status;
    }

    send(ok, err) {
        //yaCounter7501828.reachGoal('send');
        var that = this;
        console.log(true);
        $.ajax({
            type: 'POST',
            url: '/ajax/send.php',
            async: false,
            data: this.form.serialize(),
            success: function (data) {
                switch (data) {
                    case 'success':
                        that.setStatus('success');
                        break;
                    case 'resending':
                        that.setStatus('resend');
                        break;
                    case 'error':
                        that.setStatus('error');
                        break;
                }
            },
            error: err
        });
    }

    send_success() {
        var that = this;
        that.setStatus('success');
        console.log('No send Email');
    }


    /*
     send(ok, err) {
     yaCounter7501828.reachGoal('send');
     console.log(true);
     $.ajax({
     type: 'POST',
     url: '/ajax/send.php',
     data: this.form.serialize(),
     success: ok,
     error: err
     });
     }
     */

    clear() {
        $(this.form).trigger('reset');
    }
}

$('form').submit(function (e) {
    e.preventDefault();

    let form = new Form($(this));
    let self = $(this);

    if (self.find('[name="search"]').length > 0) {
        return;
    }

    let checkbox = self.find('[name="obrabotkaDanix"]');
    if (checkbox.length > 0 && !checkbox.is(':checked')) {
        alert('Пожалуйста, подтвердите обработку персональных данных');
        return;
    }

    if (!form.isValid()) {
        for (let name in form.errors)
            self.find('[name="' + name + '"]').next().text(form.errors[name][0]);

        return;
    }

    // if (form.getValues().email != undefined && form.getValues().email != '') {
    //     $.ajax({
    //         type: 'post',
    //         // url: 'https://www.email.qmotors.ru/add_subscriber.html',
    //         url: 'https://email.qmotors.ru/',
    //         data: {
    //             email: form.getValues().email,
    //             campaign_token: 'b'
    //         },
    //         error: e => {
    //             console.log(e);
    //         }
    //     });
    // }

    if (form.getValues().action == undefined || form.getValues().action != 'mark-by-photo') {
        if (form.getValues().phone != undefined && form.getValues().phone != '') {
            /*
------------------ CEB ------------------
CEB 2Gis: +7 (499) 288-19-46 // 74992881946 // 298071
CEB Контекстная реклама: +7 (499) 495-42-73 // 74994954273 // 383373
CEB Соцсети: +7 (499) 110-53-81 // 74991105381 // 223387
CEB Яндекс карты СЕВ: +7 (499) 288-20-54 // 74992882054 // 298350
CEB Весь остальной трафик: +7 (495) 150-70-36 // 74951507036 // 206505
------------------ ЛБН ------------------
ЛБН 2Gis: +7 (499) 322-41-93 // 74993224193 // 298077
ЛБН Контекстная реклама: +7 (499) 495-10-63 // 74994951063 // 383523
ЛБН Соцсети: +7 (499) 110-42-85 // 74991104285 // 226675
ЛБН Яндекс карты ЛБН: +7 (499) 490-14-95 // 74994901495 // 298359
ЛБН Весь остальной трафик: +7 (495) 150-70-73 // 74951507073 // 206503
------------------ КЛЖ ------------------
КЛЖ 2Gis: +7 (499) 495-12-37 // 74994951237 // 298080
КЛЖ Контекстная реклама: +7 (499) 444-54-05 // 74994445405 // 383526
КЛЖ Яндекс карты КЛЖ: +7 (499) 322-34-22 // 74993223422 // 298377
КЛЖ соцсети: +7 (499) 288-00-37 // 74992880037 // 298467
КЛЖ Весь остальной трафик: +7 (495) 374-50-55 // 74953745055 // 206501
------------------ УДЛ ------------------
УДЛ 2gis: +7 (499) 288-06-84 // 74992880684 // 298074
УДЛ Контекстная реклама: +7 (499) 495-40-73 // 74994954073 // 383529
УДЛ Соцсети: +7 (499) 110-27-34 // 74991102734 // 298380
УДЛ Яндекс карты УДЛ: +7 (499) 288-13-76 // 74992881376 // 298344
УДЛ Весь остальной трафик: +7 (495) 150-77-21 // 74951507721 // 206499
-----------------------------------------
            */
            let q800333 = "";
            if ($('select[name=dealer]').val() === "sevastopolskoy") {
                q800333 = document.getElementById("sev").innerHTML;
            } else if ($('select[name=dealer]').val() === "dmitrovka") {
                q800333 = document.getElementById("lbn").innerHTML;
            } else if ($('select[name=dealer]').val() === "sevastopolskoy_cleaning") {
                q800333 = '74991108063';
            } else if ($('select[name=dealer]').val() === "dmitrovka_cleaning") {
                // q800333 = document.getElementById("lbn_cleaning").innerHTML;
                q800333 = '+7 (499) 288-14-38';
            } else if ($('select[name=dealer]').val() === "michurinskiy") {
                q800333 = document.getElementById("ydal").innerHTML;
            } else if ($('select[name=dealer]').val() === "koluzshskaya") {
                q800333 = document.getElementById("klg").innerHTML;
            }

            q800333 = q800333.replace("<div>", "");
            q800333 = q800333.replace("</div>", "");

            let phone_number = q800333.replace(/[^\d]/g, '');
            let phonezrr = form.getValues().phone;

            phonezrr = phonezrr.replace(/\D+/g, "");

            var t = +new Date() + 10000;
            let group_code = '';
            console.log('---------');
            console.log(phone_number);
            console.log('---------');
            if (phone_number === '74992881946') { // CEB 2Gis
                group_code = '298071';
            } else if (phone_number === '74994954273') { // CEB Контекстная реклама
                group_code = '383373';
            } else if (phone_number === '74991105381') { // CEB Соцсети
                group_code = '223387';
            } else if (phone_number === '74992882054') { // CEB Яндекс карты
                group_code = '298350';
            } else if (phone_number === '74951507036') { // CEB Весь остальной трафик
                group_code = '206505';
            } else if (phone_number === '74993224193') { // ЛБН 2Gis
                group_code = '298077';
            } else if (phone_number === '74994951063') { // ЛБН Контекстная реклама
                group_code = '383523';
            } else if (phone_number === '74991104285') { // ЛБН Соцсети
                group_code = '226675';
            } else if (phone_number === '74994901495') { // ЛБН Яндекс карты
                group_code = '298359';
            } else if (phone_number === '74951507073') { // ЛБН Весь остальной трафик
                group_code = '206503';
            } else if (phone_number === '74994951237') { // КЛЖ 2Gis
                group_code = '298080';
            } else if (phone_number === '74994445405') { // КЛЖ Контекстная реклама
                group_code = '383526';
            } else if (phone_number === '74993223422') { // КЛЖ Яндекс карты
                group_code = '298377';
            } else if (phone_number === '74992880037') { // КЛЖ соцсети
                group_code = '298467';
            } else if (phone_number === '74953745055') { // КЛЖ Весь остальной трафик
                group_code = '206501';
            } else if (phone_number === '74992880684') { // УДЛ 2gis
                group_code = '298074';
            } else if (phone_number === '74994954073') { // УДЛ Контекстная реклама
                group_code = '383529';
            } else if (phone_number === '74991102734') { // УДЛ Соцсети
                group_code = '298380';
            } else if (phone_number === '74992881376') { // УДЛ Яндекс карты
                group_code = '298344';
            } else if (phone_number === '74951507721') { // УДЛ Весь остальной трафик
                group_code = '566915';
                // 206499
            } else if (phone_number === '74992881438') { // Дмитровка
                group_code = '427905';
            } else if (phone_number === '74991108063') { // севак
                group_code = '205833';
            }

            //
            // 01.08.22 Принудительное на лобненскую на этот номер - +7 (495) 150-70-73 / Дима
            //
            //group_code = '206503';

            if ($('select[name=dealer]').val() === "komtrans") {
                let comTrans = document.getElementById("lbn").innerHTML;
                comTrans = comTrans.replace(/[^\d]/g, '');
                if (comTrans === '84994954327') {
                    group_code = '406026';
                } else {
                    group_code = '368139';
                }
                //phone_number = "78001";
            }
            // console.log(phonezrr+'--'+group_code);
            if (phonezrr !== "70000000000" && phonezrr !== "80000000000") {
                console.log("Дозвон прошел");
                ComagicWidget.sitePhoneCall({phone: phonezrr, group_id: group_code, delayed_call_time: t.toString()});
                sendDataToServer('lobnya', phonezrr, 'red_phone');
            } else {
                console.log("group_code=" + group_code);
                console.log("Не пропускаем звонок");
            }

            // var settings = {
            //     "url": "https://api.qrenta.ru/sitephone/code_perezvon?phone=" + phone_number + "&site=1&name=Forma&phone_client="+phonezrr+"&form_service_name="+$('select[name=dealer]').val(),
            //     "method": "GET",
            //     "timeout": 0,
            //     "headers": {
            //         "x-api-key": "de78fc74-4c5b-4412-aa0a-ffefbfb6d0db"
            //     },
            // };
            // $.ajax(settings).done(function (response) {
            //     var id_ploshadki = "206505"; // По дефолту ставим Севак, если код не получен по какой либо причине
            //     if(response['success']){
            //         id_ploshadki = response['data']['code_perezvon'];
            //     }
            //     if(phonezrr !== "70000000000" && phonezrr !== "80000000000"){
            //         console.log("Дозвон прошел");
            //         ComagicWidget.sitePhoneCall({phone: phonezrr, group_id: id_ploshadki, delayed_call_time: t.toString()});
            //     }else{
            //         console.log("Не пропускаем звонок");
            //     }
            // });

            // let array_of_dealers_for_comagic = new Array();
            // if (q800333 == '+7 (495) 150-70-36') {
            //     array_of_dealers_for_comagic['sevastopolskoy'] = 206505; // 1
            //     array_of_dealers_for_comagic['koluzshskaya'] = 206501; // 4
            //     array_of_dealers_for_comagic['dmitrovka'] = 206503; // 3
            //     //array_of_dealers_for_comagic['nizhegorod'] = 205831;
            //     array_of_dealers_for_comagic['michurinskiy'] = 206499; // 2
            // } else if (q800333 == '+7 (499) 288-19-46') {//2gis
            //     array_of_dealers_for_comagic['sevastopolskoy'] = 298071;
            //     array_of_dealers_for_comagic['koluzshskaya'] = 298077;
            //     array_of_dealers_for_comagic['dmitrovka'] = 298077;
            //     array_of_dealers_for_comagic['michurinskiy'] = 298074;
            // } else if (q800333 == '+7 (499) 288-20-54') {//яндекс карты https://yandex.ru/maps/org
            //     array_of_dealers_for_comagic['sevastopolskoy'] = 298350;
            //     array_of_dealers_for_comagic['koluzshskaya'] = 298377;
            //     array_of_dealers_for_comagic['dmitrovka'] = 298359;
            //     array_of_dealers_for_comagic['michurinskiy'] = 298344;
            // } else if (q800333 == '+7 (499) 110-53-81') {//соцсети facebook.com
            //     array_of_dealers_for_comagic['sevastopolskoy'] = 223387;
            //     array_of_dealers_for_comagic['koluzshskaya'] = 298467;
            //     array_of_dealers_for_comagic['dmitrovka'] = 226675;
            //     array_of_dealers_for_comagic['michurinskiy'] = 298380;
            // } else if (q800333 == '+7 (499) 653-56-23') {//Контекстная реклама utm_source=yandex_rsya
            //     array_of_dealers_for_comagic['sevastopolskoy'] = 223583;
            //     array_of_dealers_for_comagic['koluzshskaya'] = 223581;
            //     array_of_dealers_for_comagic['dmitrovka'] = 298470;
            //     array_of_dealers_for_comagic['michurinskiy'] = 223579;
            // } else{
            //     array_of_dealers_for_comagic['sevastopolskoy'] = 206505;
            //     array_of_dealers_for_comagic['koluzshskaya'] = 206501;
            //     array_of_dealers_for_comagic['dmitrovka'] = 206503;
            //     //array_of_dealers_for_comagic['nizhegorod'] = 205831;
            //     array_of_dealers_for_comagic['michurinskiy'] = 206499;
            // }
            // console.log('***' + q800333 + '***'+array_of_dealers_for_comagic[ $('select[name=dealer]').val() ]+'+++');
            // if (window.ComagicWidget) {
            //     let t = +new Date() + 10000;
            //     let selected_location = array_of_dealers_for_comagic[ $('select[name=dealer]').val() ];
            //     ComagicWidget.sitePhoneCall({phone: form.getValues().phone, delayed_call_time: t.toString(), group_id: selected_location});
            // }
        }
        form.send_success();

        //form.send();
    } else {
        let data = new FormData($(this)[0]);
        yaCounter7501828.reachGoal('send');
        $.ajax({
            type: 'POST',
            url: '/ajax/send.php',
            dataType: 'json',
            data: data,
            async: false,
            processData: false,
            contentType: false,
            error: function (e) {
                console.log(e);
                switch (e.responseText) {
                    case 'success':
                        form.setStatus('success');
                        break;
                    case 'resending':
                        form.setStatus('resend');
                        break;
                    case 'error':
                        form.setStatus('error');
                        break;
                }
            }
        });
    }
    form.clear();
    //Modal.show(form.getStatus());
    Modal.show('#success_send_popup');
});

/* MODALS FORMS END */

function r(f) {
    /in/.test(document.readyState) ? setTimeout('r(' + f + ')', 9) : f();
}

r(function () {
    if (!document.getElementsByClassName) {
        // Поддержка IE8
        var getElementsByClassName = function (node, classname) {
            var a = [];
            var re = new RegExp('(^| )' + classname + '( |$)');
            var els = node.getElementsByTagName("*");
            for (var i = 0, j = els.length; i < j; i++)
                if (re.test(els[i].className))
                    a.push(els[i]);
            return a;
        };
        var videos = getElementsByClassName(document.body, "youtube");
    } else {
        var videos = document.getElementsByClassName("youtube");
    }

    function players(event) {
        var elem = event.target;
        if (elem.className == 'play') {
            elem = event.target.parentNode;
        }

        // Создаем iFrame и сразу начинаем проигрывать видео, т.е. атрибут autoplay у видео в значении 1
        var iframe = document.createElement("iframe");
        var iframe_url = "https://www.youtube.com/embed/" + elem.id + "?autoplay=1&autohide=1";
        if (elem.getAttribute("data-params"))
            iframe_url += '&' + elem.getAttribute("data-params");
        iframe.setAttribute("src", iframe_url);
        if (elem.getAttribute("data-allow"))
            iframe.setAttribute("allow", elem.getAttribute("data-allow"));
        iframe.setAttribute("frameborder", '0');
        iframe.setAttribute("id", "yt_" + elem.id);

        // Высота и ширина iFrame будет как у элемента-родителя
        iframe.style.width = elem.style.width;
        iframe.style.height = elem.style.height;

        var cloned = elem.cloneNode();
        var closer = document.getElementById("close_" + elem.id);
        console.log(closer);
        closer.addEventListener('click', function () {
            var play = document.createElement("div");
            play.setAttribute("class", "play");
            cloned.appendChild(play);
            cloned.addEventListener('click', players);
            iframe.parentNode.replaceChild(cloned, iframe);
        }, {passive: true});

        // Заменяем начальное изображение (постер) на iFrame
        elem.parentNode.replaceChild(iframe, elem);
    }
    ;

    var nb_videos = videos.length;
    for (var i = 0; i < nb_videos; i++) {
        // Находим постер для видео, зная ID нашего видео
        videos[i].style.backgroundImage = 'url(http://i.ytimg.com/vi/' + videos[i].id + '/sddefault.jpg)';

        // Размещаем над постером кнопку Play, чтобы создать эффект плеера
        var play = document.createElement("div");
        play.setAttribute("class", "play");
        videos[i].appendChild(play);
        videos[i].addEventListener('click', players, {passive: true});

    }
});


/* MODALS HOPE BANNER */
$(document).ready(function () {

    /* close modal window */
    $('.close_hope_banner').on('click', function () {
        $('#hope_banner_overlay').addClass('hide_banner');
    });

    /* open modal window */
    function readCookie(name) {
        var nameEQ = encodeURIComponent(name) + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0)
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    // let showHopeBanner = function () {
    //     $('#hope_banner_overlay').removeClass('hide_banner');
    //     document.cookie = "hopeBaner=true; expires=0; path=/";
    //     if(typeof popupReachGoals === "function") {
    //         popupReachGoals();
    //     }
    // };

    // if (!readCookie("hopeBaner")) {
    //     if(window.innerWidth >= 425) {
    //         setTimeout(showHopeBanner, 35000);
    //     }
    // }

    // let banerLink = document.getElementById("open_baner");
    // if (banerLink) {
    //     banerLink.addEventListener("click", function () {
    //         showHopeBanner();
    //     }, { passive: true });
    // }


    /* send message */
    $('#hope-send').on('click', function (e) {
        e.preventDefault();
        var error = false;
        var q8003342 = document.getElementById("sevPrint3").innerHTML;
        q8003342 = q8003342.replace("<div>", "");
        q8003342 = q8003342.replace("</div>", "");
        q8003342 = q8003342.replace("<span>", "");
        q8003342 = q8003342.replace("</span>", "");

        console.log('***' + q8003342 + '***');

        // Все это перенесено на admin.qrenta.ru !!! ajax запрос ниже

        // if (q8003342 == '+7 (495) 150-70-36') {//замена на коды удл//клж//сев
        //     var selected_location_dva=206499;//206501 ////206505
        // }
        // else if (q8003342 == '+7 (499) 288-19-46') {//2gis
        //     var selected_location_dva=298074;//298077// //298071
        // }
        // else if (q8003342 == '+7 (499) 288-20-54') {//яндекс карты https://yandex.ru/maps/org
        //     var selected_location_dva=298344;//298377////298350
        // }
        // else if (q8003342 == '+7 (499) 110-53-81') {//соцсети facebook.com
        //     var selected_location_dva=298380;//298467////223387
        // }
        // else if (q8003342 == '+7 (499) 653-56-23') {//Контекстная реклама utm_source=yandex_rsya
        //     var selected_location_dva=223579;//223581////223583
        // }
        // else{
        //     var selected_location_dva=206499;//206501 ////206505
        // }
        // console.log('+*+'+selected_location_dva+'+*+');
        var name_client = document.getElementById("hope-name").value;
        var phone_client = document.getElementById("hope-phone").value;
        if (/^[\+]?\d?[ ]?[\(]?\d{3}[\)]?[ ]?\d{2,3}[- ]?\d{2}[- ]?\d{2}$/gi.test(phone_client) == false) {
            alert('Поле Номер должно быть заполнено полностью!');
            error = true;
        }
        if (/[0-9]/.test(name_client)) {
            alert('В поле Имя не могут содержаться цифры!');
            error = true;
        }
        if (/[a-zA-Z]/.test(name_client)) {
            alert('В поле Имя не могут содержаться английские буквы!');
            error = true;
        }
        if (phone_client.length < 2) {
            alert('Заполните поле Ваш телефон');
            error = true;
        }

        if (error) {
            return false;
        }

        Modal.show('#success_send_popup');

        if (window.ComagicWidget) {
            let phone_number = q8003342.replace(/[^\d]/g, '');
            var t = +new Date() + 10000;

            var settings = {
                "url": "https://api.qrenta.ru/sitephone/code_perezvon?phone=" + phone_number + "&site=1&name=" + name_client + "&phone_client=" + phone_client,
                "method": "GET",
                "timeout": 0,
                "headers": {
                    "x-api-key": "de78fc74-4c5b-4412-aa0a-ffefbfb6d0db"
                },
            };
            $.ajax(settings).done(function (response) {
                var id_ploshadki = "206505"; // По дефолту ставим Севак, если код не получен по какой либо причине
                if (response['success']) {
                    id_ploshadki = response['data']['code_perezvon'];
                }
                let comTrans = document.getElementById("lbn").innerHTML;
                comTrans = comTrans.replace(/[^\d]/g, '');
                if (comTrans === '84994954327') {
                    id_ploshadki = '406026';
                } else if (comTrans === '74994954438') {
                    id_ploshadki = '368139';
                }
                if (phone_client !== "70000000000" && phone_client !== "80000000000") {
                    console.log("Дозвон прошел");
                    ComagicWidget.sitePhoneCall({
                        phone: phone_client,
                        group_id: id_ploshadki,
                        delayed_call_time: t.toString()
                    });
                    sendDataToServer('lobnya', phone_client, 'red_phone');
                } else {
                    console.log("Не пропускаем звонок");
                }
            });
        }

        $.ajax({
            type: "POST",
            url: "/ajax/send.php",
            dataType: 'text',
            data: {
                name: name_client,
                phone: phone_client,
                action: 'diagnost',
                dealer: 'sevastopolskoy'
            },
            success: function (data) {
                //alert('Спасибо вам за обращение.');
                // Modal.show('#success_send_popup');
                //
                // if (window.ComagicWidget) {
                //
                //     // Получаем ID группы comagic из admin.qrenta.ru
                //
                //     let phone_number = q8003342.replace(/[^\d]/g, '');
                //     var t = +new Date() + 10000;
                //     // var settings = {
                //     //     "url": "https://admin.qrenta.ru/api/sitephone/code_perezvon?phone=" + phone_number + "&site=1",
                //     //     "method": "GET",
                //     //     "timeout": 0,
                //     // };
                //     // $.ajax(settings).done(function (response) {
                //     //     var id_ploshadki = "206505"; // По дефолту ставим Севак, если код не получен по какой либо причине
                //     //     if(response['status']){
                //     //         id_ploshadki = response['data']['code_perezvon'];
                //     //     }
                //     //     ComagicWidget.sitePhoneCall({phone: phone_client, group_id: id_ploshadki, delayed_call_time: t.toString()});
                //     // });
                //
                //     var settings = {
                //         "url": "https://api.qrenta.ru/sitephone/code_perezvon?phone=" + phone_number + "&site=1&name=" + name_client + "&phone_client="+phonezrr,
                //         "method": "GET",
                //         "timeout": 0,
                //         "headers": {
                //             "x-api-key": "de78fc74-4c5b-4412-aa0a-ffefbfb6d0db"
                //         },
                //     };
                //     $.ajax(settings).done(function (response) {
                //         var id_ploshadki = "206505"; // По дефолту ставим Севак, если код не получен по какой либо причине
                //         if(response['success']){
                //             id_ploshadki = response['data']['code_perezvon'];
                //         }
                //         ComagicWidget.sitePhoneCall({phone: phone_client, group_id: id_ploshadki, delayed_call_time: t.toString()});
                //     });
                //
                //
                //     //var t = +new Date() + 10000;
                //     ////var selected_location = 205833;
                //     //ComagicWidget.sitePhoneCall({phone: phone_client, delayed_call_time: t.toString(), group_id: selected_location_dva});
                // }
                location.reload();
            },
            error: function (xhr, status, error) {
                console.log(xhr, status, error);
            }
        });

    });

});

/* YANDEX MAP CODE */
window.addEventListener("load", function () {

    let ymapContainer = document.querySelector(".ymap-container");

    if (ymapContainer) {
        ymapContainer.style.backgroundImage = "url('/map/yandex-before-load.jpg')";
        ymapContainer.style.backgroundColor = "#FFFFFF";
        ymapContainer.style.backgroundPosition = "center";
        ymapContainer.style.backgroundSize = "cover";
        ymapContainer.style.backgroundRepeat = "no-repeat";
    }

}, {passive: true});

//Переменная для включения/отключения индикатора загрузки
var spinner = $('.ymap-container').children('.loader');
//Переменная для определения была ли хоть раз загружена Яндекс.Карта (чтобы избежать повторной загрузки при наведении)
var check_if_load = false;
//Необходимые переменные для того, чтобы задать координаты на Яндекс.Карте
var myMapTemp, myPlacemarkTemp;

//Функция создания карты сайта и затем вставки ее в блок с идентификатором "map-yandex"
function init() {
    var elements1 = document.querySelectorAll('.block-lob');
    var elements2 = document.querySelectorAll('.block-sev');
    var elements3 = document.querySelectorAll('.block-ud');
    var elements4 = document.querySelectorAll('.block-nau');
    if (!(elements1.length == 0 && elements2.length == 0 && elements3.length == 0)) {
        ymap();
        $("#ya-map").parent('section').addClass('showFullMap');
        $("#aside").fadeOut();
    }

    var myMapTemp = new ymaps.Map("map-yandex", {
        center: [55.750138, 37.594238], // координаты центра на карте
        zoom: 10, // коэффициент приближения карты
        controls: ['zoomControl', 'fullscreenControl'] // выбираем только те функции, которые необходимы при использовании
    });

    var myPlacemark3 = new ymaps.Placemark([55.687650, 37.487982], {balloonContent: '<strong>ул. Удальцова, 60</strong><br><br><strong>Ежедневно с 8:00 до 22:00</strong><br>'}, {
        iconLayout: 'default#image',
        iconImageSize: [40, 57],
        iconImageHref: '/map/karta2.png'
    });

    var myPlacemark = new ymaps.Placemark([55.892144, 37.524160], {balloonContent: '<strong>Лобненская, 17 стр.1</strong><br><br><strong>Ежедневно с 8:00 до 22:00</strong><br>',}, {
        iconLayout: 'default#image',
        iconImageSize: [40, 57],
        iconImageHref: '/map/karta2.png'
    });

    var myPlacemark4 = new ymaps.Placemark([55.635345, 37.543578], {balloonContent: '<strong>Севастопольский пр-т, 95б</strong><br><br><strong>Ежедневно с 8:00 до 22:00</strong><br>',}, {
        iconLayout: 'default#image',
        iconImageSize: [40, 57],
        iconImageHref: '/map/karta2.png'
    });

    var myPlacemark2 = new ymaps.Placemark([55.655718, 37.553078], {balloonContent: '<strong>Научный пр-д, дом 14А, стр. 8</strong><br><br><strong>Ежедневно с 8:00 до 22:00</strong><br>',}, {
        iconLayout: 'default#image',
        iconImageSize: [40, 57],
        iconImageHref: '/map/karta2.png'
    });
    if (!elements4.length == 0) {
        myMapTemp.geoObjects.add(myPlacemark2); // помещаем флажок на карту
    }
    if (!elements1.length == 0) {
        myMapTemp.geoObjects.add(myPlacemark); // помещаем флажок на карту
    }
    if (!elements3.length == 0) {
        myMapTemp.geoObjects.add(myPlacemark3); // помещаем флажок на карту
    }
    if (!elements2.length == 0) {
        myMapTemp.geoObjects.add(myPlacemark4); // помещаем флажок на карту
    }
    // Получаем первый экземпляр коллекции слоев, потом первый слой коллекции
    var layer = myMapTemp.layers.get(0).get(0);

    // Решение по callback-у для определния полной загрузки карты
    waitForTilesLoad(layer).then(function () {
        // Скрываем индикатор загрузки после полной загрузки карты
        spinner.removeClass('is-active');
    });
}

// Функция для определения полной загрузки карты (на самом деле проверяется загрузка тайлов)
function waitForTilesLoad(layer) {
    return new ymaps.vow.Promise(function (resolve, reject) {
        var tc = getTileContainer(layer), readyAll = true;
        tc.tiles.each(function (tile, number) {
            if (!tile.isReady()) {
                readyAll = false;
            }
        });
        if (readyAll) {
            resolve();
        } else {
            tc.events.once("ready", function () {
                resolve();
            });
        }
    });
}

function getTileContainer(layer) {
    for (var k in layer) {
        if (layer.hasOwnProperty(k)) {
            if (
                layer[k] instanceof ymaps.layer.tileContainer.CanvasContainer
                || layer[k] instanceof ymaps.layer.tileContainer.DomContainer
            ) {
                return layer[k];
            }
        }
    }
    return null;
}

// Функция загрузки API Яндекс.Карт по требованию (в нашем случае при наведении)
function loadScript(url, callback) {
    var script = document.createElement("script");

    if (script.readyState) {  // IE
        script.onreadystatechange = function () {
            if (script.readyState == "loaded" ||
                script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  // Другие браузеры
        script.onload = function () {
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

// Основная функция, которая проверяет когда мы навели на блок с классом "ymap-container"
var ymap = function () {
    $('.ymap-container').mouseenter(function () {
            if (!check_if_load) { // проверяем первый ли раз загружается Яндекс.Карта, если да, то загружаем

                // Чтобы не было повторной загрузки карты, мы изменяем значение переменной
                check_if_load = true;

                // Показываем индикатор загрузки до тех пор, пока карта не загрузится
                spinner.addClass('is-active');

                // Загружаем API Яндекс.Карт
                loadScript("https://api-maps.yandex.ru/2.1/?lang=ru_RU&amp;loadByRequire=1", function () {
                    // Как только API Яндекс.Карт загрузились, сразу формируем карту и помещаем в блок с идентификатором "map-yandex"
                    ymaps.load(init);
                });
            }
        }
    );
};

function loadYMap() {
    if (!check_if_load) {
        check_if_load = true;
        spinner.addClass('is-active');

        loadScript("https://api-maps.yandex.ru/2.1/?lang=ru_RU&loadByRequire=1", function () {
            ymaps.load(init);
        });
    }
}

$(function () {
    //Запускаем основную функцию
    ymap();

    var ymapContainer = document.querySelector('.ymap-container');
// Если ширина экрана < 700, добавляем авто-загрузку при появлении на экране
    if (window.innerWidth < 700) {
        if ('IntersectionObserver' in window) {
            let observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        loadYMap(); // Загружаем карту
                        observer.disconnect(); // Отключаем наблюдение после загрузки
                    }
                });
            }, {
                rootMargin: '100px' // Немного заранее
            });

            observer.observe(ymapContainer);
        } else {
            // Fallback для старых браузеров
            loadYMap();
        }
    }
});

/* AKPP QUIZ */
var steps = [false, false, false, false, false, false];
var curr_step = 0;
var int_val = 0; //для проверки площади
//
// возможность возвращаться к предыдущему вопросу
function set_history(index) {
    if (!(window.history && history.pushState)) {
        return false;
    }
    if (steps[index] == false) {
        history.pushState({'step_x': index}, null, window.location.href);
        steps[index] = true;
    }
}


// переходы по шагам
function to_step(index, need_push) {
    curr_step = index;
    for (var i = 0; i < steps.length; i++) {
        if (!$("#step" + i).is(':hidden')) {
            $("#step" + i).hide();
        }
    }
    ;
    $("#step" + index).show();

    let progress_percents = (100 * index / steps.length);
    $("#progressbar").css({width: progress_percents + "%"});
    $("#progressbar").text(Math.round(progress_percents) + "%");
    $("#curr_step").text("Шаг " + index + " из " + (steps.length - 1));

    // Разделение на #step0, #other_steps и #last_step
    if (index + 1 == steps.length) { // если шаг равен общему количеству шагов
        if (!$("#other_steps").is(':hidden')) {
            $("#other_steps").hide();
            $("#last_step").show();
        }
    } else if (index > 0) { // если шаг больше ноля
        if ($("#other_steps").is(':hidden')) {
            $("#other_steps").show();
        }
        if (!$("#last_step").is(':hidden')) {
            $("#last_step").hide();
        }
    } else if (!$("#other_steps").is(':hidden')) { // если шаг равен нолю
        $("#other_steps").hide();
    }
}


// Проверка заполненности радиокнопки или чекбокса
function check_radio_selected(elem_id, error_message) {
    let obj = $('input[name="' + elem_id + '"]:checked');
    if (!(obj.length && obj.val())) {
        alert(error_message);
        return false;
    }
    return true;
}

// Проверки полей по шагам и уведомления при незаполненных полях
(function ($) {

    $(document).ready(function () {
        to_step(0, true);
    }); // задаем первоначальный индекс

    $("#to_step1").click(function (event) {
        event.preventDefault();
        to_step(1, true);
    });

    $("#to_step2").click(function (event) {
        event.preventDefault();
        if (check_radio_selected("type-model", "Выберите модель")) {
            to_step(2, true);
        }
    });

    $("#to_step3").click(function (event) {
        event.preventDefault();
        if (check_radio_selected("type-engine", "Выберите тип двигателя")) {
            to_step(3, true);
        }
    });

    $("#to_step4").click(function (event) {
        event.preventDefault();

        if (check_radio_selected("type-status", "Укажите состояние вашего автомобиля")) {
            to_step(4, true);
        }
    });

    $("#to_step5").click(function (event) {
        event.preventDefault();
        if (check_radio_selected("type-defect", "Укажите неполадки в работе автомобиля")) {
            to_step(5, true);
        }
    });

    // Отправка формы (нажатием на финальную кнопку)
    $("#to_submit").click(function (event) {
        event.preventDefault();
        submitQuizForm();
    });

    // Проверка телефона и ПК при отправке формы
    function submitQuizForm() {

        let form = new Form($('#quiz_form'));

        let name_client = $('#quiz_form').find('#name_input').val();
        let phone_client = $('#quiz_form').find('#phone_input').val();

        console.log(name_client);
        console.log(phone_client);
        if (name_client == '') {
            alert('Заполните поле с именем');
            return false;
        }
        if (phone_client == '') {
            alert('Заполните поле с номером телефона');
            return false;
        } else if (phone_client.length < 8) {
            alert('Слишком короткий номер');
            return false;
        } else if (!((phone_client.lastIndexOf("+7", 0) === 0) || (phone_client.lastIndexOf("8", 0) === 0))) {
            alert('Введите корректный номер в формате +79998887766 или 89998887766');
            return false;
        }
        if (!$('input:checkbox[name="acceptance"]').is(':checked')) {
            alert('Вы должны ознакомиться с политикой конфиденциальности');
            return false;
        }

        $.ajax({
            type: "POST",
            url: "/ajax/send.php",
            dataType: 'text',
            data: {
                name: name_client,
                phone: phone_client,
                action: 'akkp_quiz',
                dealer: 'sevastopolskoy',
                brand: $('#quiz_form').find("input[name=brand]").val(),
                model: $('#quiz_form').find("input[name=type-model]:checked").val(),
                engine: $('#quiz_form').find("input[name=type-engine]:checked").val(),
                status: $('#quiz_form').find("input[name=type-status]:checked").val(),
                defect: $('#quiz_form').find("input[name=type-defect]:checked").val()
            },
            success: function (data) {
                switch (data) {
                    case 'success':
                        Modal.show('#success');
                        form.clear();
                        $('#last_step').hide();
                        to_step(0, false);
                        break;
                    case 'resending':
                        Modal.show('#resend');
                        form.clear();
                        break;
                    case 'error':
                        Modal.show('#error');
                        break;
                }
                /*
                if (window.ComagicWidget) {
                    var t = +new Date() + 10000;
                    var selected_location = 205833;
                    ComagicWidget.sitePhoneCall({phone: phone_client, delayed_call_time: t.toString(), group_id: selected_location});
                }*/
            },
            error: function (xhr, status, error) {
                console.log(xhr, status, error);
                Modal.show('#error');
            }
        });
        return false;
    };


    // для возврата к предыдущему вопросу
    window.addEventListener("popstate", function (e) {
        var step = 0;
        if (e.state) {
            step = e.state.step_x;
        }
        to_step(step);
    }, {passive: true});

})(jQuery);


$(document).ready(function () {

    jQuery('body').on('change', '#quiz_form', function () {

        // Обводка для label input[type=radio]
        $('input[type=radio]').each(function () {
            if ($(this).is(':checked')) {
                $(this).parent('label').addClass('checked');
            } else {
                $(this).parent('label').removeClass('checked');
            }
        });

        // Обводка для label input[type=checkbox]
        $('input[type=checkbox]').each(function () {
            if ($(this).is(':checked')) {
                $(this).parent('label').addClass('checked');
            } else {
                $(this).parent('label').removeClass('checked');
            }
        });

    });

    // Поле ввода внутри label для input[type=radio]
    $("#up-layer").click(function () {
        $("#price_input").focus();
    });

});

$(document).ready(function () {
    $('.single-slide').slick();

    $('.slider-vacancy').find(".slick-arrow").addClass("event_click_button");
    $('.event_click_button').click(function () {
        var id = $(this).parents('.slider-vacancy').data('id');
        $('#h2_name_master_' + id).html($(this).parents('.slider-vacancy').find(".slick-active").data('master_name'));
    });
})


$(document).ready(function () {
    if ($('#get_size').width() !== undefined) {
        setInterval(() => {
            resize_video();
        }, 2000);
        $('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            // adaptiveHeight: true,
            mobileFirst: true,
            lazyLoad: 'ondemand',
            asNavFor: '.slider-nav'
        });
        $('.slider-nav').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            dots: true,
            arrows: false,
            centerMode: true,
            // adaptiveHeight: true,
            mobileFirst: true,
            focusOnSelect: true,
        });
    }

    function resize_video() {
        var width = $('#get_size').width();
        var height = $('#get_size').height();
        $('.video_resize').css('heidth', height + 'px');
        $('.video_resize').css('width', width + 'px');
        $('.div_video_resize').css('padding-top', height + 'px');
    }
})
$(document).ready(function () {
    const width_screen = window.screen.width;
    if (width_screen < 700) {
        $('#reviews_show_more_button').css({'display': 'block'});
        $('#reviews_show_more_text').css({'display': 'none'});
    } else {
        $('#reviews_show_more_button').css({'display': 'none'});
        $('#reviews_show_more_text').css({'display': 'block'});
    }

    $(".phone_certificates").click(function (e) {
        let value_number = $(this).siblings('input').val();
        value_number = value_number.replace(/[^\d]/g, '');
        let t = +new Date() + 10000;
        ComagicWidget.sitePhoneCall({phone: value_number, group_id: '407712', delayed_call_time: t.toString()});
        sendDataToServer('lobnya', value_number, 'red_phone');
        Modal.show('#success_send_popup');
    });
})

function open_more_reviews() {
    $('#reviews_show_more_button').css({'display': 'none'});
    $('#reviews_show_more_text').css({'display': 'block'});
}

$(document).ready(function () {
    $('.accordion__item__content').slideUp();
    $('.active_accordion_item').find('.accordion__item__btn').addClass('accordion_active').parent().find('.accordion__item__content').slideDown();

    $(".accordion__item__btn").click(function () {
        $('.accordion__item__btn').removeClass('accordion_active');
        $('.accordion__item__btn').parent().find('.accordion__item__content').slideUp();
        $(this).addClass('accordion_active');
        const click_slide = $(this).parent().find('.accordion__item__content');
        click_slide.slideDown();
    });
});
$(document).ready(function () {
    $('.block66-slider').slick({
        slidesToShow: 4,
        infinity: false,
        slidesToScroll: 1,
        lazyLoad: 'progressive',
        responsive: [
            {
                breakpoint: 1799,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});
